"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var store_1 = require("../../store/store");
var legacy_1 = require("satcheljs/lib/legacy");
/**
 * Set the InboxRuleDiagnosticRequestStatus in the inbox rules options store
 * @param requestStatus the get inbox rules diagnostic request status to set
 */
exports.default = legacy_1.action('setInboxRuleDiagnosticRequestStatus')(function setInboxRuleDiagnosticRequestStatus(requestStatus) {
    store_1.default.inboxRulesListState.getInboxRuleDiagnosticRequestStatus = requestStatus;
});
//# sourceMappingURL=setInboxRuleDiagnosticRequestStatus.js.map


//////////////////
// WEBPACK FOOTER
// ./obj/options/config/mail/owa-inbox-rules-option/lib/actions/helpers/setInboxRuleDiagnosticRequestStatus.js
// module id = 3752
// module chunks = 2